<template>
  <router-view />
</template>

<style>
:root {
  --ink: #12151c;
  --ink-muted: #4a5568;
  --paper: #e9edf2;
  --paper-deep: #d8e0e9;
  --surface: #f4f6f9;
  --accent: #0e7490;
  --accent-soft: rgba(14, 116, 144, 0.12);
  --line: rgba(18, 21, 28, 0.12);
  --footer: #12151c;
  --font-display: 'Familjen Grotesk', sans-serif;
  --font-body: 'IBM Plex Sans', sans-serif;
  --font-mono: 'IBM Plex Mono', monospace;
  --ease: cubic-bezier(0.22, 1, 0.36, 1);
  --max: 720px;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: var(--paper);
  color: var(--ink);
  font-family: var(--font-body);
  font-size: 1.0625rem;
  line-height: 1.65;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
  text-align: left;
}

a {
  color: var(--accent);
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  transition: color 0.2s var(--ease), background-color 0.2s var(--ease);
}

a:hover {
  color: var(--ink);
}

::selection {
  background: var(--accent-soft);
  color: var(--ink);
}

img {
  max-width: 100%;
  display: block;
}
</style>
